import "@/App.css";
import "./i18n/config";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SidebarProvider } from "./context/SidebarContext";
import { MainLayout } from "./components/Layout/MainLayout";
import { Login } from "./pages/Login";
import { PatrolLogin } from "./pages/PatrolLogin";
import { Dashboard } from "./pages/Dashboard";
import { Companies } from "./pages/Companies";
import { Users } from "./pages/Users";
import { Checkpoints } from "./pages/Checkpoints";
import { Routes as RoutesPage } from "./pages/Routes";
import { Patrol } from "./pages/Patrol";
import { PatrolLogs } from "./pages/PatrolLogs";
import { Payroll } from "./pages/Payroll";
import { Setup } from "./pages/Setup";
import { GuardLoginRecords } from "./pages/GuardLoginRecords";
import { ActiveGuards } from "./pages/ActiveGuards";
import Holidays from "./pages/Holidays";
import CompanySettings from "./pages/CompanySettings";
import WorkSchedules from "./pages/WorkSchedules";
import GuardScheduleCalendar from "./pages/GuardScheduleCalendar";
import { PunchRecords } from "./pages/PunchRecords";
import { ChangePassword } from "./pages/ChangePassword";
import VisitorsDashboard from "./pages/visitors/VisitorsDashboard";
import VisitorRegistry from "./pages/visitors/VisitorRegistry";
import AccessControl from "./pages/visitors/AccessControl";
import QrScanner from "./pages/visitors/QrScanner";
import Preauthorizations from "./pages/visitors/Preauthorizations";
import VisitHistory from "./pages/visitors/VisitHistory";
import VehiclesEquipment from "./pages/visitors/VehiclesEquipment";
import VisitIncidents from "./pages/visitors/VisitIncidents";
import VisitReports from "./pages/visitors/VisitReports";
import VisitorSetup from "./pages/visitors/VisitorSetup";
import GuardVisitorsLayout from "./pages/visitors/GuardVisitorsLayout";
import { Toaster } from "./components/ui/sonner";

// Pantallas del módulo de visitas reservadas a admin, revendedor y supervisor
const ManagerOnly = ({ children }) => {
  const { canManage } = useAuth();
  return canManage() ? children : <Navigate to="/visitors" replace />;
};

function App() {
  return (
    <AuthProvider>
      <SidebarProvider>
        <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/patrol/login" element={<PatrolLogin />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/change-password" element={<ChangePassword />} />
          
          {/* Patrol route (separate from main layout) */}
          <Route path="/patrol" element={<Patrol />} />

          {/* Control de visitas del vigilante, dentro de la interfaz de patrulla */}
          <Route path="/patrol/visitors" element={<GuardVisitorsLayout />}>
            <Route index element={<VisitorsDashboard />} />
            <Route path="access" element={<AccessControl />} />
            <Route path="scan" element={<QrScanner />} />
            <Route path="preauths" element={<Preauthorizations />} />
            <Route path="registry" element={<VisitorRegistry />} />
            <Route path="history" element={<VisitHistory />} />
            <Route path="vehicles" element={<VehiclesEquipment />} />
            <Route path="incidents" element={<VisitIncidents />} />
          </Route>
          
          {/* Protected routes with main layout */}
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/users" element={<Users />} />
            <Route path="/checkpoints" element={<Checkpoints />} />
            <Route path="/routes" element={<RoutesPage />} />
            <Route path="/patrol-logs" element={<PatrolLogs />} />
            <Route path="/guard-records" element={<GuardLoginRecords />} />
            <Route path="/active-guards" element={<ActiveGuards />} />
            <Route path="/payroll" element={<Payroll />} />
            <Route path="/holidays" element={<Holidays />} />
            <Route path="/work-schedules" element={<WorkSchedules />} />
            <Route path="/guard-schedule-calendar" element={<GuardScheduleCalendar />} />
            <Route path="/punch-records" element={<PunchRecords />} />
            <Route path="/company-settings" element={<CompanySettings />} />
            {/* Control de Visitas */}
            <Route path="/visitors" element={<VisitorsDashboard />} />
            <Route path="/visitors/registry" element={<VisitorRegistry />} />
            <Route path="/visitors/access" element={<AccessControl />} />
            <Route path="/visitors/scan" element={<QrScanner />} />
            <Route path="/visitors/preauths" element={<Preauthorizations />} />
            <Route path="/visitors/history" element={<VisitHistory />} />
            <Route path="/visitors/vehicles" element={<VehiclesEquipment />} />
            <Route path="/visitors/incidents" element={<VisitIncidents />} />
            <Route path="/visitors/reports" element={<ManagerOnly><VisitReports /></ManagerOnly>} />
            <Route path="/visitors/setup" element={<ManagerOnly><VisitorSetup /></ManagerOnly>} />
          </Route>
          
          {/* Redirect root to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;
